<template>
  <div class="bn-shell">
    <nav class="bn-bar" role="navigation" aria-label="Үндсэн цэс">
      <div class="bn-bar__track">
        <router-link
          v-for="item in navBeforeFab()"
          :key="item.to"
          :to="item.to"
          tag="button"
          type="button"
          class="bn-item"
          active-class="bn-item--active"
        >
          <i :class="[item.icon, 'bn-item__icon']" aria-hidden="true" />
          <span class="bn-item__label">{{ item.label }}</span>
        </router-link>

        <button
          v-if="checkPermissionsPage('app_menu_add_item')"
          type="button"
          class="bn-fab"
          aria-label="Нүүр — шинэ бүртгэл"
          @click="addItem"
        >
          <i class="el-icon-plus" aria-hidden="true" />
        </button>

        <router-link
          v-for="item in navAfterFab()"
          :key="item.to"
          :to="item.to"
          tag="button"
          type="button"
          class="bn-item"
          active-class="bn-item--active"
        >
          <i :class="[item.icon, 'bn-item__icon']" aria-hidden="true" />
          <span class="bn-item__label">{{ item.label }}</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { checkPermissions } from '@/helpers/custom'

const beforeFab = [
  { to: '/trackcodes', label: 'Жагсаалт', icon: 'el-icon-s-order', perm: 'app_menu_jagsaalt' },
  { to: '/measuringOut', label: 'Олголт', icon: 'el-icon-box', perm: 'app_menu_olgolt' },
  { to: '/configPage', label: 'Тохиргоо', icon: 'el-icon-setting', perm: 'app_menu_tohirgoo' },
  { to: '/packagePage', label: 'Багц', icon: 'el-icon-s-cooperation', perm: null }
]

const afterFab = [
  { to: '/cargo', label: 'Ачаа', icon: 'el-icon-folder-opened', perm: 'app_menu_cargo' },
  { to: '/trackCodeHistory', label: 'Түүх', icon: 'el-icon-time', perm: 'app_menu_tvvh' },
  { to: '/profile', label: 'Профайл', icon: 'el-icon-user', perm: 'app_menu_profile' }
]

export default {
  name: 'NavigationBar',
  methods: {
    navBeforeFab () {
      return beforeFab.filter((e) => e.perm == null || checkPermissions(e.perm))
    },
    navAfterFab () {
      return afterFab.filter((e) => e.perm == null || checkPermissions(e.perm))
    },
    addItem () {
      this.$router.push('/')
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    }
  }
}
</script>

<style scoped>
.bn-shell {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  padding: 0 0 env(safe-area-inset-bottom, 0px);
  pointer-events: none;
}

.bn-shell * {
  pointer-events: auto;
}

.bn-bar {
  margin: 0 10px 10px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow:
    0 -4px 24px rgba(15, 23, 42, 0.08),
    0 8px 32px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.bn-bar__track {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  gap: 2px;
  padding: 8px 6px 10px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.bn-bar__track::-webkit-scrollbar {
  display: none;
}

.bn-item {
  flex: 1 0 auto;
  min-width: 52px;
  max-width: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  padding: 6px 4px 4px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font: inherit;
  border-radius: 14px;
  transition: color 0.2s ease, background 0.2s ease, transform 0.15s ease;
}

.bn-item:hover,
.bn-item:focus {
  color: #64748b;
  outline: none;
  background: rgba(241, 245, 249, 0.9);
}

.bn-item--active {
  color: #409eff;
  background: rgba(236, 253, 245, 0.5);
}

.bn-item--active .bn-item__icon {
  transform: translateY(-1px);
}

.bn-item__icon {
  font-size: 22px;
  line-height: 1;
  transition: transform 0.15s ease;
}

.bn-item__label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 1.15;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bn-fab {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  margin: -26px 4px 0;
  border: none;
  border-radius: 50%;
  background: linear-gradient(145deg, #409eff 0%, #337ecc 100%);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 6px 18px rgba(64, 158, 255, 0.45),
    0 2px 6px rgba(15, 23, 42, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bn-fab:hover,
.bn-fab:focus {
  transform: scale(1.05);
  outline: none;
  box-shadow:
    0 8px 22px rgba(64, 158, 255, 0.5),
    0 2px 8px rgba(15, 23, 42, 0.15);
}

.bn-fab:active {
  transform: scale(0.97);
}

.bn-fab .el-icon-plus {
  font-size: 26px;
  font-weight: bold;
}
</style>
